import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Box, Button, Container, Typography, Stack } from '@mui/material';
import { Error as ErrorIcon, Refresh as RefreshIcon, Home as HomeIcon } from '@mui/icons-material';

const ServerError = () => {
  const handleRefresh = () => {
    window.location.reload();
  };

  return (
    <Container maxWidth="md">
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '100vh',
          textAlign: 'center',
        }}
      >
        <ErrorIcon sx={{ fontSize: 60, color: 'error.main', mb: 2 }} />
        <Typography variant="h1" color="error" sx={{ fontSize: '8rem', fontWeight: 600 }}>
          500
        </Typography>
        <Typography variant="h4" gutterBottom>
          Error Interno del Servidor
        </Typography>
        <Typography variant="body1" color="textSecondary" paragraph>
          Ha ocurrido un error en el servidor. Estamos trabajando para resolverlo.
        </Typography>
        <Typography variant="body2" color="textSecondary" paragraph>
          Por favor, intenta de nuevo más tarde o contacta con el soporte técnico si el problema persiste.
        </Typography>
        <Stack direction="row" spacing={2} sx={{ mt: 3 }}>
          <Button
            variant="contained"
            color="primary"
            startIcon={<RefreshIcon />}
            onClick={handleRefresh}
          >
            Recargar Página
          </Button>
          <Button
            component={RouterLink}
            to="/dashboard"
            variant="outlined"
            color="primary"
            startIcon={<HomeIcon />}
          >
            Ir al Dashboard
          </Button>
        </Stack>
      </Box>
    </Container>
  );
};

export default ServerError;